import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { CryptoWalletBase } from '@zero/self-service/feature-crypto-wallet/base';
import { FormateIBANPipe } from '@zero/shared/ui-pipes';
import { ButtonComponent, CopyToClipboardComponent } from '@zero/shared/ui-web-design-system';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  selector: 'self-service-crypto-wallet',
  templateUrl: './crypto-wallet.component.html',
  imports: [CopyToClipboardComponent, RouterLink, AsyncPipe, TranslocoPipe, FormateIBANPipe, ButtonComponent, UpperCasePipe],
})
export class CryptoWalletComponent extends CryptoWalletBase implements OnInit {
  public readonly commonRoutes = commonRoutes;

  ngOnInit(): void {
    this.init();
  }
}
